import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  MenuItem,
  Box
} from '@mui/material';

const RestaurantEditDialog = ({ open, restaurant, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    phone: '',
    cuisine_type: '',
    rating: '',
    notes: ''
  });

  const cuisineTypes = [
    'Chinese',
    'Italian',
    'Japanese',
    'Thai',
    'Indian',
    'French',
    'Mexican',
    'American',
    'Korean',
    'Vietnamese',
    'Mediterranean',
    'Other'
  ];

  useEffect(() => {
    if (restaurant) {
      setFormData({
        name: restaurant.name || '',
        address: restaurant.address || '',
        phone: restaurant.phone || '',
        cuisine_type: restaurant.cuisine_type || '',
        rating: restaurant.rating || '',
        notes: restaurant.notes || ''
      });
    } else {
      setFormData({
        name: '',
        address: '',
        phone: '',
        cuisine_type: '',
        rating: '',
        notes: ''
      });
    }
  }, [restaurant]);

  const handleInputChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleSave = () => {
    onSave(formData);
  };

  const isEditing = !!restaurant;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {isEditing ? `Edit Restaurant: ${restaurant?.name}` : 'Add New Restaurant'}
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Restaurant Name"
            value={formData.name}
            onChange={handleInputChange('name')}
            fullWidth
            required
          />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                label="Cuisine Type"
                value={formData.cuisine_type}
                onChange={handleInputChange('cuisine_type')}
                fullWidth
              >
                <MenuItem value="">Select cuisine type</MenuItem>
                {cuisineTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                label="Rating"
                type="number"
                value={formData.rating}
                onChange={handleInputChange('rating')}
                fullWidth
                inputProps={{ min: 1, max: 5, step: 0.1 }}
                helperText="Rating from 1 to 5"
              />
            </Grid>
          </Grid>

          <TextField
            label="Address"
            value={formData.address}
            onChange={handleInputChange('address')}
            fullWidth
            multiline
            rows={2}
          />

          <TextField
            label="Phone"
            value={formData.phone}
            onChange={handleInputChange('phone')}
            fullWidth
          />

          <TextField
            label="Notes"
            value={formData.notes}
            onChange={handleInputChange('notes')}
            fullWidth
            multiline
            rows={3}
            placeholder="Personal notes, favorite dishes, etc..."
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          {isEditing ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RestaurantEditDialog;